import { Component, OnInit } from '@angular/core';
import { SharedService } from '../service/shared.service';
import { ApiServiceService } from '../service/api-service.service';
import { configuration } from 'src/configuration';

@Component({
  selector: 'app-payment-list',
  templateUrl: './payment-list.component.html',
  styleUrls: ['./payment-list.component.css']
})
export class PaymentListComponent implements OnInit {

  paymentData: any = []
  constructor(public shared: SharedService, public apiService: ApiServiceService) {
    this.shared.isWhiteMenu = true;
  }

  ngOnInit(): void {
    this.initData()
  }

  async initData() {
    let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.GET_PAYMENT_REQUEST_DATA, {});
    if (res && !res.error && res.data) {
      this.paymentData = res.data
    }
  }



}
